module.exports = __webpack_public_path__ + "c919a4470875e906f6f2c41bf9938ad8.png";